class Header {
    constructor(el) {
        this.header = el;
        this.hamburger = el.querySelector('.hamburger');
        this.searchButtons = el.querySelectorAll('.search-icon');
        this.crosses = el.querySelectorAll('.cross-icon');
        this.searchFormInput = this.header.querySelector('.search-form__input');
        this.attachListeners();
    }

    attachListeners() {
        this.hamburger.addEventListener('click', event => this.toggleMenuOverlay(event));
        this.searchButtons.forEach(button => button.addEventListener('click', () => this.toggleSearchForm()));
    }

    toggleMenuOverlay() {
        event.preventDefault();
        this.header.classList.toggle('-overlay');
        document.querySelector('body').classList.toggle('-overflow');
    }

    toggleSearchForm() {
        let searchForm = document.querySelectorAll('.search-form');

        //if there are more than 2 search form present, it means you're on the search page overview. Only one should be shown in that case.
        if (searchForm.length > 1) {
            searchForm = searchForm[1];
            document.querySelectorAll('.search-icon').forEach(icon => icon.addEventListener('click', event => {
                event.preventDefault();
                setTimeout(() => searchForm.querySelector('.search-form__input').focus(), 150);
            }));
        } else {
            searchForm = searchForm[0];
            searchForm.classList.toggle('-open');
            this.searchButtons.forEach(button => button.classList.toggle('-hide'));
            this.crosses.forEach(button => button.classList.toggle('-show'));
            this.crosses.forEach(button => {
                button.addEventListener('click', () => {
                    this.crosses.forEach(button => button.classList.remove('-show'));
                    this.searchButtons.forEach(button => button.classList.remove('-hide'));
                    searchForm.classList.remove('-open');
                });
            });
        }

        setTimeout(() => this.searchFormInput.focus(), 150);
    }
}

export default el => new Header(el);
